<template>
  <div>
    <!-- <aside v-if="fixedLeftTop && leftTopList.length>0"
           :style="{'background-image': 'url(' + leftTopList[0].imgLink + ')' }"
           class="service-left-top">
      <ul v-if="leftTopList.length>1">
        <li class="slot">
          <a v-if="leftTopList[1].imgClickLink" @click.prevent="goHref(leftTopList[1].imgClickLink)">
            <img :src="leftTopList[1].imgLink" alt="">
          </a>
          <img v-if="!leftTopList[1].imgClickLink" :src="leftTopList[1].imgLink" alt="">
        </li>
        <li class="closed" title="关闭" @click="fixedLeftTop = false">
          X
        </li>
      </ul>
    </aside>

    <div v-if="fixedrightTop && rightTopList.length>0" class="home-right-top">
      <i class="el-icon-error close-btn" @click="fixedrightTop = false"></i>
      <a v-if="rightTopList[0].imgClickLink" @click.prevent="goHref(rightTopList[0].imgClickLink)">
        <img :src="rightTopList[0].imgLink" alt="">
      </a>
      <img v-if="!rightTopList[0].imgClickLink" :src="rightTopList[0].imgLink" alt="">
    </div> -->
       <!-- 左上 -->
    <aside v-if="fixedLeftTop && leftTopList.length>0"
           :style="{'background-image': 'url(' + leftTopList[0].imgLink + ')' }"
           class="service-left-top" @click.prevent="goHref(leftTopList[0].imgClickLink)">
      <i  class="el-icon-error close-btn" @click.stop="fixedLeftTop = false" v-if="leftTopList.length==1"></i>
      <ul v-if="leftTopList.length>1">
        <li class="slot">
          <!-- <a v-if="leftTopList[1].imgClickLink" @click.prevent="goHref(leftTopList[1].imgClickLink)">
            <img :src="leftTopList[1].imgLink" alt="">
          </a> -->
          <img :src="leftTopList[1].imgLink" alt="" @click.stop="goHref(leftTopList[1].imgClickLink)" v-if="leftTopList.length>=2">
          <img :src="leftTopList[2].imgLink" alt="" @click.stop="goHref(leftTopList[2].imgClickLink)" v-if="leftTopList.length>=3">
        </li>
        <li class="closed" title="关闭" @click.stop="fixedLeftTop = false">
          X
        </li>
      </ul>
    </aside>
    <!-- 右上 -->
    <aside v-if="fixedrightTop && rightTopList.length>0"
           :style="{'background-image': 'url(' + rightTopList[0].imgLink + ')' }"
           class="service-right-top" @click.prevent="goHref(rightTopList[0].imgClickLink)">
       <i  class="el-icon-error close-btn" @click.stop="fixedrightTop = false" v-if="rightTopList.length==1"></i>
      <ul v-if="rightTopList.length>1">
        <li class="slot">
          <!-- <a v-if="rightTopList[1].imgClickLink" @click.prevent="goHref(rightTopList[1].imgClickLink)">
            <img :src="rightTopList[1].imgLink" alt="">
          </a> -->
          <!-- <img v-if="!rightTopList[1].imgClickLink" :src="rightTopList[1].imgLink" alt=""> -->
          <img :src="rightTopList[1].imgLink" alt="" @click.stop="goHref(rightTopList[1].imgClickLink)" v-if="rightTopList.length>=2">
          <img :src="rightTopList[2].imgLink" alt="" @click.stop="goHref(rightTopList[2].imgClickLink)" v-if="rightTopList.length>=3">
        </li>
        <li class="closed" title="关闭" @click.stop="fixedrightTop = false">
          X
        </li>
      </ul>
    </aside>

    <div v-if="fixedLeftMid && leftMiddleList.length>0" ref="leftMiddle" class="home-left-middle fixedItem">
      <ul>
        <li v-for="item in leftMiddleList" :key="item.id" class="discounts">
          <a v-if="item.imgClickLink" @click.prevent="goHref(item.imgClickLink)">
            <img :src="item.imgLink" alt="">
          </a>
          <img v-if="!item.imgClickLink" :src="item.imgLink" alt="">
        </li>
        <li class="close"><span title="关闭" @click="fixedLeftMid = false">关闭</span></li>
      </ul>
    </div>

    <div v-if="fixedRightMid && rightMiddleList.length>0" ref="rightMiddle" class="home-right-middle fixedItem">
      <ul>
        <li v-for="item in rightMiddleList" :key="item.id" class="discounts">
          <a v-if="item.imgClickLink" @click.prevent="goHref(item.imgClickLink)">
            <img :src="item.imgLink" alt="">
          </a>
          <img v-if="!item.imgClickLink" :src="item.imgLink" alt="">
        </li>
        <li class="close"><span title="关闭" @click="fixedRightMid = false">关闭</span></li>
      </ul>
    </div>

    <div v-if="fixedLeftBottom && leftBottomList.length>0" class="home-left-bottom fixedItem_bottom">
      <i class="el-icon-error close-btn"
         @click="fixedLeftBottom = false"></i>
      <a v-if="leftBottomList[0].imgClickLink" @click.prevent="goHref(leftBottomList[0].imgClickLink)" target="_blank">
        <img :src="leftBottomList[0].imgLink" alt="">
      </a>
      <img v-if="!leftBottomList[0].imgClickLink" :src="leftBottomList[0].imgLink" alt="">
    </div>

    <div v-if="fixedRightBottom && rightBottomList.length>0" class="home-right-bottom fixedItem_bottom">
      <i class="el-icon-error close-btn"
         @click="fixedRightBottom = false"></i>
      <a v-if="rightBottomList[0].imgClickLink" @click.prevent="goHref(rightBottomList[0].imgClickLink)" target="_blank">
        <img :src="rightBottomList[0].imgLink" alt="">
      </a>
      <img v-if="!rightBottomList[0].imgClickLink" :src="rightBottomList[0].imgLink" alt="">
    </div>

  </div>
</template>

<script>
  /*eslint-disable*/
  import {commonApi, common} from '@/common/index';
  import {PENDANT_LEFT, PENDANT_RIGHT, PENDANT_TOP_LEFT, PENDANT_TOP_RIGHT, PENDANT_BOTTOM_LEFT, PENDANT_BOTTOM_RIGHT} from '../../assets/js/bannerCode'

  export default {
    name: 'aside-pendant',
    data() {
      return {
        fixedLeftTop: true,
        fixedrightTop: true,
        fixedLeftMid: true,
        fixedRightMid: true,
        fixedLeftBottom: true,
        fixedRightBottom: true,

        leftTopList: [],
        rightTopList: [],

        leftMiddleList: [],
        rightMiddleList: [],

        leftBottomList: [],
        rightBottomList: [],
      }
    },
    methods: {
      goHref(url) {
        let path = common.goHref(url);
        if(path) {
          this.$router.push({path: path})
        }
      },
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(this.fixedLeftMid && this.leftMiddleList.length>0) {
          this.$refs.leftMiddle.style.top = 190 + scrollTop +'px';
        }
        if(this.fixedRightMid && this.rightMiddleList.length>0) {
          this.$refs.rightMiddle.style.top = 190 + scrollTop +'px';
        }
      },
      fetchImg() {
        // let wnsPCPendantLeftTop = commonApi.HOMEBEFORE.fetchImg(PENDANT_TOP_LEFT);
        // let wnsPCPendantRightTop = commonApi.HOMEBEFORE.fetchImg(PENDANT_TOP_RIGHT);


        // let wnsPCPendantMiddleLeft = commonApi.HOMEBEFORE.fetchImg(PENDANT_LEFT);
        // let wnsPCPendantMiddleRight = commonApi.HOMEBEFORE.fetchImg(PENDANT_RIGHT);

        // let wnsPCPendantBottomLeft = commonApi.HOMEBEFORE.fetchImg(PENDANT_BOTTOM_LEFT);
        // let wnsPCPendantBottomRight = commonApi.HOMEBEFORE.fetchImg(PENDANT_BOTTOM_RIGHT);

        // Promise.all([wnsPCPendantLeftTop, wnsPCPendantRightTop, wnsPCPendantMiddleLeft, wnsPCPendantMiddleRight, wnsPCPendantBottomLeft, wnsPCPendantBottomRight])
        //   .then(data => {
        //     this.leftTopList = data[0];
        //     this.rightTopList = data[1];
        //     this.leftMiddleList = data[2];
        //     this.rightMiddleList = data[3];
        //     this.leftBottomList = data[4];
        //     this.rightBottomList = data[5];
        //   })
        //   .catch(err=>{})
          let imgCodes = [PENDANT_TOP_LEFT,PENDANT_TOP_RIGHT,PENDANT_LEFT,PENDANT_RIGHT,PENDANT_BOTTOM_LEFT,PENDANT_BOTTOM_RIGHT].join(',')
            commonApi.HOMEBEFORE.fetchImgs(imgCodes)
            .then(data=>{
              this.leftTopList = data.yhPCPendantTopLeft;
              this.rightTopList = data.yhPCPendantTopRight;
              this.leftMiddleList = data.yhPCPendantLeft;
              this.rightMiddleList = data.yhPCPendantRight;
              this.leftBottomList = data.yhPCPendantBottomLeft;
              this.rightBottomList = data.yhPCPendantBottomRight;
            })
      },
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    mounted() {
      this.fetchImg();
      this.$nextTick(() => {
        window.addEventListener('scroll',this.handleScroll)
      })
    }
  };
</script>

<style scoped lang="scss">
  // 首页样式
  aside{display: block;}
  .service-left-top {position: fixed;top: 0;left: 0;z-index: 2001;width: 175px;height: 175px;background-repeat:no-repeat;background-size: 100% 100%;cursor: pointer;
    &:hover{overflow: visible;ul{transform: skew(180deg);opacity: 1;}}
    .slot{height: 100%;}
    .close-btn{position: absolute;top: 0;left: 0;color: #ad0202;font-size: 24px;cursor: pointer}
    ul{position: absolute;transform: skewX(145deg);opacity: 0;top: 0;left: 0;overflow: hidden;transition: all .6s;display: inline-block;margin: 0 auto;padding: 0;list-style: none;transform-origin: left top;} //width: 240px;
    a {display: block;height: 100%;}
    .closed{position: absolute;top: 0;right: 0;font-size:20px;text-align: center;line-height: 26px;width: 26px;height: 26px;}
  }
   .service-right-top {position: fixed;top: 0;right: 0px;z-index: 2001;width: 175px;height: 175px;background-repeat:no-repeat;background-size: 100% 100%;cursor: pointer;
    &:hover{overflow: visible;ul{transform: skew(180deg);opacity: 1;}}
    .slot{height: 100%;}
    .close-btn{position: absolute;top: 0;right: 0;color: #ad0202;font-size: 24px;cursor: pointer}
    ul{position: absolute;transform: skewX(225deg);opacity: 0;top: 0;right: 0;overflow: hidden;transition: all .6s;display: inline-block;margin: 0 auto;padding: 0;list-style: none;transform-origin: left top;} //width: 240px;
    a {display: block;height: 100%;}
    .closed{position: absolute;left: 0;top: 0;font-size:20px;text-align: center;line-height: 26px;width: 26px;height: 26px;}
  }

  .fixedItem{position: absolute;z-index: 2000;top: 190px;transition: all 0.5s linear;background-size: 100% 100%;background-repeat: no-repeat;background-position: center;}
  .home-left-middle,.home-right-middle{
    ul{
      li{cursor: pointer;text-align: center;}
      .close{
        span{color: #ffffff;width: 50px;letter-spacing: 3px;display: inline-block;height: 20px;line-height: 20px;vertical-align: top;background-color: #ad0202;border-bottom-left-radius: 6px;border-bottom-right-radius: 6px}
      }

      a{display: inline-block;width: 100%;height: 100%}
    }
  }
  .home-right-middle{right: 0;}
  .fixedItem_bottom{position: fixed;z-index: 2000;bottom: 0;transition: all 0.5s;background-size: 100% 100%;background-repeat: no-repeat;background-position: center;}

  .home-left-bottom{left: 0;cursor: pointer;
    .close-btn{position: absolute;top: 0;right: 0;color: #ad0202;font-size: 24px;cursor: pointer}
  }
  .home-right-bottom{right: 0;cursor: pointer;
    .close-btn{position: absolute;top: 0;right: 0;color: #ad0202;font-size: 24px;cursor: pointer}
  }
</style>



// WEBPACK FOOTER //
// src/pages/build901/components/pendant/aside-pendant.vue